import { getDateForIms } from 'js/hooks/useFormatter/helpers';

import * as Types from './types';
import { BONUS_AMOUNT_TYPES } from './constants';

export const formatDateForIms = (time?: Date): string => {
    const timeRaw = time ? new Date(time) : new Date();

    timeRaw.setMilliseconds(0);

    return getDateForIms(timeRaw);
};

export const getPeriod = (): { fromDate: Date; toDate: Date } => {
    const fromDate = new Date();
    const toDate = new Date(fromDate);

    fromDate.setFullYear(fromDate.getFullYear() - 10);

    return {
        fromDate,
        toDate
    };
};

export const getBonusAmount = ({ bonus, translate, formatCurrency }: Types.IGetBonusAmountParams): string => {
    const { playType, freeSpinsCountRemaining, freeSpinsCount, goldenChips, amount: { amount, currencyCode } } = bonus;

    switch (playType) {
        case BONUS_AMOUNT_TYPES.FREE_SPINS:
        case BONUS_AMOUNT_TYPES.FREE_SPINS2:
            return translate('freeSpinsCount.value',
                [freeSpinsCountRemaining || 0, freeSpinsCount || 0]);

        case BONUS_AMOUNT_TYPES.GOLDEN_CHIPS:
            return translate('goldenChipsCount.value',
                [goldenChips?.goldenChipsCountRemaining || 0, goldenChips?.goldenChipsCount || 0]);

        default:
            return formatCurrency(amount, { currencyCode });
    }
};
